module.exports = __webpack_public_path__ + "img/tuxsuite-logo.0c007164.svg";